import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Div as TrackedClickDiv } from 'reactSite/Analytics'

const baseStyles = ({ theme }) => css`
  label: images-carousel;

  ${theme.media.giga} {
    border: 1px solid ${theme.colors.n100};
    border-radius: ${theme.borderRadius.mega};
  }

  .swiper-slide {
    height: auto;
  }

  .swiper-pagination-bullet {
    background: ${theme.colors.p500};
    opacity: 1;
    transition: ${theme.transition.leave} ease;
    width: 11px;
    height: 11px;
  }

  .swiper-pagination-bullet-active {
    transition: ${theme.transition.leave} ease;
  }

  .swiper-pagination-custom {
    width: auto;
  }

  .swiper-button-disabled {
    cursor: not-allowed;

    &:hover {
      svg {
        fill: inherit;
      }
    }
  }

  img {
    label: images-carousel__image;

    display: block;

    height: auto;
    max-width: 100%;
    width: 100%;
  }

  iframe {
    label: images-carousel__image;

    position: absolute;
    left: 0;
    top: 0;

    height: 100%;
    width: 100%;

    z-index: 2;
  }
`

const counterStyles = ({ theme }) => css`
  label: images-carousel__counter;

  position: absolute;
  top: 8px;
  right: 8px;

  z-index: 2;
`

const imageWrapperStyles = () => css`
  label: images-carousel__image-wrapper;

  cursor: zoom-in;
`

export const Wrapper = styled('div')(baseStyles)
export const Counter = styled('div')(counterStyles)
export const ImageWrapper = styled(TrackedClickDiv)(imageWrapperStyles)
